import { __awaiter, __generator } from "tslib";
import { useCallback, useState } from "react";
function useApiWrapper(setDataInCaller) {
    var _this = this;
    var _a = useState(false), inProgress = _a[0], setInProgress = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(null), data = _c[0], setData = _c[1];
    var apiWrapper = useCallback(function (apiCall) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInProgress(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiCall()];
                case 2:
                    response = _a.sent();
                    setData(response);
                    setDataInCaller && setDataInCaller(response);
                    return [2 /*return*/, response];
                case 3:
                    error_1 = _a.sent();
                    setError(error_1);
                    return [2 /*return*/, Promise.reject(error_1)];
                case 4:
                    setInProgress(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    return { inProgress: inProgress, error: error, data: data, apiWrapper: apiWrapper };
}
;
export default useApiWrapper;
